<template>
  <div class="orderList" v-loading="loading">
    <div class="wrap">
      <h2>订单列表</h2>
    </div>

    <el-table :data="tableData" style="width: 100%">
      <el-table-column label="姓名" align="center" prop="user.mem_name">
      </el-table-column>
      <el-table-column label="手机号" align="center" prop="user.mem_phone">
      </el-table-column>
      <el-table-column label="订单编号" align="center" prop="numbers">
      </el-table-column>
      <el-table-column
        label="支付宝/微信 交易流水号"
        align="center"
        prop="trade_no"
      >
      </el-table-column>
      <el-table-column
        label="创建时间"
        align="center"
        prop="created_at"
      ></el-table-column>
      <el-table-column label="订单类型" align="center" prop="name">
      </el-table-column>
      <el-table-column label="支付类型" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.pay_type == 1">微信公众号支付</span>
          <span v-if="scope.row.pay_type == 2">微信扫码支付</span>
          <span v-if="scope.row.pay_type == 3">微信h5</span>
          <span v-if="scope.row.pay_type == 10">支付宝扫码</span>
        </template>
      </el-table-column>
      <el-table-column
        label="支付金额"
        align="center"
        prop="pay"
      ></el-table-column>
      <el-table-column label="订单状态" align="center">
        <template slot-scope="scope">
          <el-link v-if="scope.row.status == 1" type="success">已完成</el-link>
          <el-link v-if="scope.row.status == 0" type="warning">待支付</el-link>
          <el-link v-if="scope.row.status == 2" type="danger">进行中</el-link>
          <el-link v-if="scope.row.status == 3" type="danger">订单失败</el-link>
          <el-link v-if="scope.row.status == 4" type="danger">超时关闭</el-link>
        </template>
      </el-table-column>
    </el-table>
    <div class="pages" v-if="total">
      <div class="pages-item">
        <!-- <p class="pages-text">
          每页显示{{ pageSize }} 条记录，共 {{ total }}条记录
        </p> -->
      </div>
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-size="pageSize"
        prev-text="上一页"
        next-text="下一页"
        layout="prev, pager, next"
        :total="total"
        class="pages-item"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  name: "orderList",
  data() {
    return {
      tableData: [],
      pageSize: 50,
      total: 0,
      search: "",
      page: 1,
      loading: false,
      user_id: "",
      paper_id: "",
      img_show: false,
      file: "",
      classData: [],
    };
  },
  created() {
    let _this = this;
    _this.paper_id = this.$route.query.id;
    _this.init();
  },
  methods: {
    init() {
      let _this = this;
      _this.$http
        .post(process.env.VUE_APP_API_URL + "admin/order", {
          id: _this.paper_id,
        })
        .then(function(data) {
          if (data.data.code == 200) {
            _this.tableData = data.data.data;
          } else {
            _this.$message.error(data.data.msg);
          }
        })
        .catch(function(error) {
          _this.$message.error({ message: "网络错误,请刷新界面重试" });
          return;
        });
    },
    handleCurrentChange() {},
  },
};
</script>

<style lang="less" scoped>
.pages {
  padding: 10px;
  background-color: #f6f9fc;
  text-align: right;
  font-size: 14px;
  color: #606266;
  .pages-item {
    display: inline-block;
    vertical-align: middle;
  }
  .el-pagination {
    margin-left: 20px;
  }
}
.wrap {
  display: flex;
  height: 50px;
  align-items: center;
  justify-content: space-between;
}
.search-btn {
  width: 300px !important;
  margin-left: 30px;
}
</style>
